import { render, staticRenderFns } from "./AnnouncementDetailsDialog.vue?vue&type=template&id=48a72814&scoped=true"
import script from "./AnnouncementDetailsDialog.vue?vue&type=script&lang=js"
export * from "./AnnouncementDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementDetailsDialog.vue?vue&type=style&index=0&id=48a72814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a72814",
  null
  
)

export default component.exports